import React from "react";
import styled from "styled-components";
import { ChevronRight, CurlyBraces, FormInput, ToggleRight } from "lucide-react";
import {} from "../../../../router/RouterUtils";
import DeprecatedH1 from "../../../../deprecated/DeprecatedH1";
import DeprecatedH4 from "../../../../deprecated/DeprecatedH4";

const Container = styled.div`
  @media (min-width: 1330px) {
    margin: 32px auto;
    max-width: 75%;
    padding-bottom: 64px;
  }
`;

const Card = styled.div`
  background: #ffffff;
  box-shadow: 0px 4px 20px -4px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  padding: 24px;
`;

const ShadedArea = styled.div`
  border-radius: 10px;
  width: 100%;
  display: block;
  background: #eff6ff;
  padding: 16px 20px;
`;

const Button = styled.button`
  background: var(--blue40);
  border-radius: 6px;
  outline: 0;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 12px;
  line-height: 22px;
  padding: 5px 12px 5px 16px;
  gap: 2px;
  border: none;
  box-shadow: none;

  &:hover,
  &:focus-visible {
    background: var(--blue30);
  }
`;

const SensitiveData = () => {
  return (
    <Container>
      <Card>
        <DeprecatedH1 className="deprecated-mb-3">Sensitive Data</DeprecatedH1>
        <DeprecatedH4 className="deprecated-mb-5 gray font-normal">
          Utilize Merge&apos;s various features to control user data.
        </DeprecatedH4>

        <p className="deprecated-mb-5">
          There are three ways to control data access within Merge&apos;s Unified API:
        </p>

        <ShadedArea className="deprecated-mb-4">
          <ToggleRight size={16} color="var(--blue40)" style={{ marginBottom: 12 }} />

          <DeprecatedH4 className="deprecated-mb-3">Custom Scopes</DeprecatedH4>

          <Button onClick={() => window.open("", "_blank")}>
            View docs <ChevronRight size={12} />
          </Button>
        </ShadedArea>
        <ShadedArea className="deprecated-mb-4">
          <FormInput size={16} color="var(--blue40)" style={{ marginBottom: 12 }} />

          <DeprecatedH4 className="deprecated-mb-3">Selective Sync</DeprecatedH4>

          <Button onClick={() => window.open("", "_blank")}>
            View docs <ChevronRight size={12} />
          </Button>
        </ShadedArea>
        <ShadedArea className="deprecated-mb-4">
          <CurlyBraces size={16} color="var(--blue40)" style={{ marginBottom: 12 }} />
          <DeprecatedH4 className="deprecated-mb-3">API Request Parameters</DeprecatedH4>
          <Button onClick={() => window.open("", "_blank")}>
            View docs <ChevronRight size={12} />
          </Button>
        </ShadedArea>
      </Card>
    </Container>
  );
};

export default SensitiveData;
